import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './core/guards/auth.guard';
import { DefaultLayoutComponent } from './layout';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    canActivate: [loginGuard],
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then((m) => m.RegisterComponent),
    data: {
      title: 'Register Page',
    },
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [authGuard],
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./views/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        data: { title: 'Dashboard' },
      },
      {
        path: 'order',
        loadChildren: () => import('./views/operations/orders/route').then((m) => m.routes),
      },
      {
        path: 'company',
        loadChildren: () => import('./views/settings/company-master/route').then((m) => m.routes),
      },
      {
        path: 'map',
        loadChildren: () => import('./views/map/routes').then((m) => m.routes),
      },
      {
        path: 'employee-master',
        loadChildren: () => import('./views/sales/employee-master/route').then((m) => m.routes),
      },
      {
        path: 'shippers',
        loadChildren: () => import('./views/sales/shipper/route').then((m) => m.routes),
      },
      {
        path: 'vehicle-allocation',
        loadChildren: () => import('./views/operations/vehicle-allocation/routes').then((m) => m.routes),
      },
      {
        path: 'delivery-management',
        loadChildren: () => import('./views/operations/delivery-management/routes').then((m) => m.routes),
      },
      {
        path: 'shipper-payments',
        loadChildren: () => import('./views/operations/shipper-payments/routes').then((m) => m.routes),
      },
      {
        path: 'payment-management',
        loadChildren: () => import('./views/payments/payment-management/routes').then((m) => m.routes),
      },
      {
        path: 'pickup-vouchers',
        loadChildren: () => import('./views/pickups/pickup-vouchers/routes').then((m) => m.routes),
      },
      {
        path: 'pickup-allocations',
        loadChildren: () => import('./views/pickups/pickup-allocation/routes').then((m) => m.routes),
      },

      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes),
      },
      {
        path: 'role',
        loadChildren: () => import('./views/roles-screen/role/route').then((m) => m.routes),
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/routes').then((m) => m.routes), // Explicitly import `routes.ts`
      },
    ],
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then((m) => m.Page404Component),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then((m) => m.Page500Component),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'ag-example',
    loadComponent: () => import('./views/pages/ag-grid-example/ag-grid-example.component').then((m) => m.AgGridExampleComponent),
    data: {
      title: 'AG-Grid Example',
    },
  },

  { path: '**', redirectTo: 'dashboard' },
];
